import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 9, fontFamily: "Helvetica", lineHeight: 1.2 },
  headerTitle: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: 10,
  },
  section: { marginBottom: 12 },
  headerRow: { flexDirection: "row", marginBottom: 2 },
  label: { width: 140, fontWeight: "bold" },
  value: { flex: 1 },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e2e8f0",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#e2e8f0",
    minHeight: 18,
    alignItems: "center",
  },
  tableHeader: { backgroundColor: "#f8fafc", fontWeight: "bold" },
  colItem: {
    width: "65%",
    padding: "3 6",
    borderRightWidth: 1,
    borderColor: "#e2e8f0",
  },
  colQty: {
    width: "20%",
    padding: "3 6",
    borderRightWidth: 1,
    borderColor: "#e2e8f0",
    textAlign: "center",
  },
  colCheck: { width: "15%", padding: "3 6", textAlign: "center" },
  checkbox: {
    width: 10,
    height: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#94a3b8",
    alignSelf: "center",
  },
});

export const ChallanPDF = ({ order }: { order: any }) => {
  const matchedProduct = order.goods.find((item: any) => {
    const name = item?.product?.productName?.toLowerCase() || "";
    return name.includes("dcr") || name.includes("panel");
  });
  const panelMake: string = matchedProduct?.product?.productName || "N/A";
  const panelQuantity: number = matchedProduct?.quantity || "N/A";
  const reg = order.whatsappCustomerId?.productRegistration;
  const customerName =
    order.customerId?.name ||
    order.whatsappCustomerId?.customerName ||
    reg?.name ||
    "Unknown Customer";
  const mobile =
    order.whatsappCustomerId?.mobileNumber ||
    order.customerId?.mobileNumber ||
    "N/A";
  const address = order.shippingAddress;
  const fullAddress = address
    ? `${address.line1}, ${address.city}, ${address.state} - ${address.pincode}`
    : "N/A";
  const capacity = reg?.totalSolarCapacity || order.plantSize || "N/A";
  return (
    <Document title={`Challan-${order.orderNumber}`}>
      <Page size="A4" style={styles.page}>
        <Text style={styles.headerTitle}>
          DELIVERY CHALLAN - {order.orderNumber}
        </Text>

        <View style={styles.section}>
          <View style={styles.headerRow}>
            <Text style={styles.label}>NAME :-</Text>
            <Text style={styles.value}>{customerName.toUpperCase()}</Text>
          </View>
          <View style={styles.headerRow}>
            <Text style={styles.label}>MOBILE :-</Text>
            <Text style={styles.value}>{mobile}</Text>
          </View>
          <View style={styles.headerRow}>
            <Text style={styles.label}>Consumer Number :-</Text>
            <Text style={styles.value}>{reg?.consumerNumber || "N/A"}</Text>
          </View>
          <View style={styles.headerRow}>
            <Text style={styles.label}>SYSTEM SIZE :-</Text>
            <Text style={styles.value}>{capacity}</Text>
          </View>
          <View style={styles.headerRow}>
            <Text style={styles.label}>PANEL MAKE AND NOS :-</Text>
            <Text style={styles.value}>
              {panelMake} ({panelQuantity} Nos)
            </Text>
          </View>
          {/* <View style={styles.headerRow}>
            <Text style={styles.label}>INVERTER :-</Text>
            <Text style={styles.value}>{reg?.inverterCapacity || "N/A"}</Text>
          </View> */}
          <View style={styles.headerRow}>
            <Text style={styles.label}>ADDRESS :-</Text>
            <Text style={styles.value}>{reg?.address || fullAddress}</Text>
          </View>
        </View>

        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <View style={styles.colItem}>
              <Text>Product Name</Text>
            </View>
            <View style={styles.colQty}>
              <Text>Qty</Text>
            </View>
            <View style={styles.colCheck}>
              <Text>Tick</Text>
            </View>
          </View>

          {order.goods?.map((item: any, index: number) => (
            <View style={styles.tableRow} key={index} wrap={false}>
              <View style={styles.colItem}>
                <Text>
                  {item.product?.productName || item.rawMaterial?.name || "N/A"}
                </Text>
              </View>
              <View style={styles.colQty}>
                <Text>
                  {item.quantity} {item.unit || ""}
                </Text>
              </View>
              <View style={styles.colCheck}>
                <View style={styles.checkbox} />
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};
